// @ts-nocheck
import Vue from "vue";
import dateFormatter from "../../utility/dateFormatter";
export default Vue.extend({
    props: ["label", "defaultDate", "disabled", "dense", "filled"],
    data() {
        return {
            menu: false,
            date: null,
            error: null,
            dateRules: [
                (value) => this.isNonEmptyDate(value),
                (value) => this.isValidDate(value),
            ],
        };
    },
    mounted() {
        this.date = dateFormatter
            .fromServerDate(this.defaultDate)
            .toUtcDateString();
    },
    watch: {
        defaultDate(newDefaultDate) {
            this.date = dateFormatter
                .fromServerDate(newDefaultDate)
                .toUtcDateString();
        },
    },
    methods: {
        isValidDate(date) {
            if (this.canBeEmpty && this.isDateEmpty(date)) {
                return true;
            }
            const isValid = dateFormatter.validate(date).isValidDateTime();
            return isValid || "Invalid date format";
        },
        isNonEmptyDate(date) {
            if (this.canBeEmpty) {
                return true;
            }
            if (!this.isDateEmpty(date)) {
                return true;
            }
            return "Cannot be empty";
        },
        isDateEmpty(date) {
            return !(typeof date != undefined && date);
        },
        shouldUpdateDate(date) {
            if (this.canBeEmpty && this.isDateEmpty(date)) {
                return false;
            }
            // Only update date if valid
            return this.$refs.dateTextInput.validate();
        },
        async updateDate(date) {
            this.date = date;
            await this.$nextTick();
            this.menu = false;
            this.error = null;
            this.$emit("updateDate", this.date);
        },
        handleInputChanged(date) {
            if (!this.shouldUpdateDate(date)) {
                return;
            }
            this.updateDate(date);
        },
    },
});
